import { SettingsService } from '../../../services/settings.service';
import { fabric } from 'fabric';
import interact from 'interactjs';
import * as $ from 'jquery';
import { SynchronizationService } from '../../../services/synchronization.service';
import { WhiteboardIOService } from '../../../services/whiteboard-io.service';
import { ConfigLoaderService } from '../../../config/configloader.service';
import { WBUtils } from './util/WBUtils';
import { AbstractShapeFactory } from './shapes/AbstractShapeFactory';
import { RectangleFactory } from './shapes/RectangleFactory';
import { EllipseFactory } from './shapes/EllipseFactory';
import { LineFactory } from './shapes/LineFactory';
import { UMLDiamondFactory } from './shapes/UMLDiamondFactory';
import { UMLObjectFactory } from './shapes/UMLObjectFactory';
import { ScreenPhoneFactory } from './shapes/ScreenPhoneFactory';
import { ScreenTabletFactory } from './shapes/ScreenTabletFactory';
import { ScreenDesktopFactory } from './shapes/ScreenDesktopFactory';
import { WhiteboardWidgetComponent } from './whiteboard-widget.component';
import { DrawingModeHandler } from './util/drawing-mode-handler';
import { DrawingMode } from './util/drawing-mode';
import { SelectionFactory } from './shapes/SelectionFactory';
import { PencilFactory } from './shapes/PencilFactory';
import { TextFactory } from './shapes/TextFactory';
import { Image } from 'fabric/fabric-impl';

export class SmartWhiteboard {
  private mainModule: WhiteboardWidgetComponent;
  private pyWallBaseUrl: string;

  /** Canvas elements */
  private canvas: any;
  private tempCanvas: any;
  private dynamicCanvas: any;
  private pressTimer: any;
  private spinnerDelayTimer: any;
  private elementString: string;

  /** Canvas interaction temp values */
  private anchorX: number;
  private anchorY: number;
  private pointer: any;
  private drawingObject: fabric.Object;
  private snapPosition: number[];

  /** Coordinates  */
  private absoluteX: any;
  private absoluteY: any;
  private longClickX: any;
  private longClickY: any;
  private anchorOnMoveX: number;
  private anchorOnMoveY: number;
  private anchorLeftCanvasX: number;
  private anchorLeftCanvasY: number;
  private anchorLeftCanvasSet: boolean;

  /** Canvas states and values */
  private shapeFactory: AbstractShapeFactory;
  private drawingMode: DrawingMode;
  private uniqueElementId: number;
  private isInWritingMode: boolean;
  private isDown: boolean;
  private canvasLoaded: boolean;
  private timerStarted: boolean;
  private color: string;
  private fill: string;
  private stroke: number;
  private fontSize: number;
  private snapToObjects: boolean;
  private canvasLocked: boolean;
  private readonly MIN_DISTANCE = 100;
  private readonly DEFAULT_PADDING = 100;
  public readonly RESIZER_OFFSET = 12;
  private readonly CANVAS_PREVIEW_TIMEOUT = 120;
  private readonly LONG_CLICK_COPY_DURATION = 2000;
  private readonly LONG_CLICK_COPY_SPINNER_DELAY = 500;
  private readonly LONG_CLICK_COPY_RESET_DISTANCE = 20;
  private readonly LONG_CLICK_COPY_OFFSET = 20;

  /** custom dropzone */
  private dropStoryActivated: boolean;
  private dropTaskActivated: boolean;
  private dropGalleryActivated: boolean;
  private activeDropTaskID: string;
  private activeDropStoryID: string;

  constructor(
    public synchronization: SynchronizationService,
    private settingsService: SettingsService,
    private configService: ConfigLoaderService,
    private wbIOService: WhiteboardIOService) {

    this.pyWallBaseUrl = `${configService.settings.pyWallServer.url}`;
  }

  init(callingModule: any) {
    this.mainModule = callingModule;
    this.initStates();
    this.initWhiteboardValues();
    this.intiCustomDropzoneStatesAndValues();
    this.setupSelectionHandles();
    this.setupWhiteboardFabric();
  }

  private initStates() {
    this.isInWritingMode = false;
    this.canvasLocked = false;
    this.timerStarted = false;
    this.isDown = false;
    this.canvasLoaded = false;
    this.snapToObjects = false;
  }

  private initWhiteboardValues() {
    this.drawingMode = DrawingMode.PENCIL;
    this.color = '#0c0c0c';
    this.fill = 'rgba(0,0,0,0)';
    this.stroke = 5;
    this.fontSize = 32;
    this.uniqueElementId = 0;
  }

  private intiCustomDropzoneStatesAndValues() {
    this.activeDropStoryID = '';
    this.activeDropTaskID = '';
    this.dropGalleryActivated = false;
    this.dropTaskActivated = false;
    this.dropStoryActivated = false;
  }

  /**
     * Overrides the default appearance of the fabric.object
     * selection handles.
     */
  private setupSelectionHandles() {
    fabric.Object.prototype.set({
      transparentCorners: false,
      cornerSize: 32,
      cornerStyle: 'circle',
      padding: 4,
      rotatingPointOffset: 50
    });
  }

  private setupWhiteboardFabric() {
    this.prepareCanvasObject();
    this.prepareDynamicAndTemporaryCanvas();

    if (this.canvas) {
      this.setupCanvasEvents();
      this.setupWhiteboardDropZone(this);
    }
  }

  /**
     * Initializes the fabric canvas object and sets basic states.
     * Additionally it sets the canvas size according to the browser size.
     */
  private prepareCanvasObject() {
    this.canvas = new fabric.Canvas('myCanvas', {
      selectionColor: 'rgba(0, 0, 255, 0.1)',
      selectionLineWidth: 2,
      backgroundColor: '#fff',
      selectionFullyContained: true,
      selection: false,
      preserveObjectStacking: true
    });
    this.canvas.isDrawingMode = true;
    this.canvas.setHeight(window.innerHeight);
    this.canvas.setWidth(window.innerWidth);
    this.setObjectsSelectable(false);
    this.shapeFactory = new PencilFactory();
    this.setStrokeWidth(this.stroke);
  }

  /**
     * Registers all event listeners on the canvas object.
     */
  private setupCanvasEvents() {
    this.canvas.on('mouse:down', (e) => {
      this.onMouseDown(e);
    })
      .on('mouse:move', (e) => {
        this.onMouseMove(e);
      })
      .on('mouse:up', (e) => {
        this.onMouseUp(e);
      })
      .on('path:created', (e) => {
        this.dropPath(this.getUniqueElementId());
      })
      .on('selection:created', (e) => {
        this.onSelectObject();
      })
      .on('selection:updated', (e) => {
        this.onSelectObject();
      })
      .on('selection:cleared', (e) => {
        $(WBUtils.selectionContextClass).hide();
      })
      .on('object:moving', (e) => {
        this.onMoveObject(e);
      })
      .on('object:scaling', (e) => {
        this.onScaleObject(e);
        this.clearLongClickTimer();
      })
      .on('object:rotating', (e) => {
        this.onRotateObject(e);
        this.clearLongClickTimer();
      });

    $(window).on('resize', () => {
      this.canvas.setHeight(window.innerHeight);
      this.canvas.setWidth(window.innerWidth);
    });
  }

  /**
     * Initializes the dynamic and temporary canvas for rendering draggable images.
     */
  private prepareDynamicAndTemporaryCanvas() {
    this.tempCanvas = new fabric.Canvas(WBUtils.renderCanvasHTML_ID);
    this.tempCanvas.setHeight(window.innerHeight);
    this.tempCanvas.setWidth(window.innerWidth);
    this.dynamicCanvas = new fabric.StaticCanvas(WBUtils.dynamicCanvasHTML_ID);
  }

  /**
     * Executed once when mouse is clicked or event touch:start is fired. Sets different flags
     * and anchor points, calls the createObject()-function and sends a real time event.
     */
  private onMouseDown(e: any) {
    if (!this.canvasLocked) {
      this.isDown = true;
      this.mainModule.closeOthers('');
      this.pointer = this.canvas.getPointer();
      this.longClickX = this.pointer.x;
      this.longClickY = this.pointer.y;
      this.absoluteX = this.pointer.x + WBUtils.whiteboardWidget.offset().left;
      this.absoluteY = this.pointer.y + WBUtils.whiteboardWidget.offset().top + WBUtils.buttonWrapper.height();
      this.anchorX = this.pointer.x;
      this.anchorY = this.pointer.y;

      this.drawingObject = this.createObject(this.anchorX, this.anchorY);
      this.sendCreateData(this.pointer.x, this.pointer.y);
    }
  }

  /**
     * Executed every time the mouse or touch-input is moved. Checks all custom dropzones for hovering
     * draggable-previews and optionally checks for snapping anchor points. Finally calls
     * the modifyObject() method and sends a real time event.
     */
  private onMouseMove(e: any) {
    if (!this.canvasLocked) {
      this.pointer = this.canvas.getPointer();
      this.checkCustomDropzoneOnMouseMove(this.pointer);
      this.snapPosition = [];

      if (!this.isDown) {
        return;
      }

      if (this.snapToObjects) {
        this.snapPosition = this.checkObjectsToSnap(this.pointer);
      }

      if (this.snapPosition.length > 0) {
        this.modifyObject(this.anchorX, this.anchorY, this.snapPosition[0], this.snapPosition[1]);
        this.sendModifyData(this.anchorX, this.anchorY, this.snapPosition[0], this.snapPosition[1]);
      } else {
        this.modifyObject(this.anchorX, this.anchorY, this.pointer.x, this.pointer.y);
        this.sendModifyData(this.anchorX, this.anchorY, this.pointer.x, this.pointer.y);
      }
    }
  }

  /**
     * Executed once when mouse click or touch event is released. Resets states, checks custom dropzones
     * for dropped draggable previews and finally calls the copyAndDropObject()-function alongside sending
     * a real time event.
     */
  private onMouseUp(e: any) {
    if (!this.canvasLocked) {
      this.isDown = false;
      this.pointer = this.canvas.getPointer();
      this.anchorX = this.pointer.x;
      this.anchorY = this.pointer.y;


      this.anchorLeftCanvasSet = false;
      WBUtils.canvasDraggable.css('display', 'none');
      this.setAllObjectsMovable();
      this.checkCustomDropzonesOnMouseUp();

      if (!this.isInWritingMode) {
        const currentElementID = this.getUniqueElementId();
        this.copyAndDropObject(currentElementID, this.shapeFactory.getAWType());
        this.canvas.remove(this.drawingObject);
        this.sendDropSyncData(currentElementID, this.shapeFactory.getAWType());
      } else {
        this.stopModifyText();
        this.synchronization.sendRealTimeEvent(`WhiteboardWidget${WBUtils.widgetName}StopTextModify`);
      }
    }
  }

  /**
     * Sets up the dropzone listener on the canvas object in order to recognize img and draggable aWall
     * images and drop them to the canvas.
     */
  private setupWhiteboardDropZone(component: any) {
    interact(WBUtils.dropZoneTarget).dropzone({
      accept: WBUtils.dropZoneAccept,
      ondrop: (e) => {
        if ($(e.relatedTarget).is('img')) {
          this.onDropImage(e.relatedTarget.src, e.dragEvent.pageX, e.dragEvent.pageY);
        } else {
          if ($(e.relatedTarget).hasClass(WBUtils.draggableImageClass)) {
            const uid = e.relatedTarget.uniqueId;
            const closest = e.relatedTarget.closest(`.${WBUtils.draggableImageClass}`);
            closest.parentElement.removeChild(closest);
            this.synchronization.sendRealTimeEvent(`GalleryDraggableImage${uid}CloseImage`);
          }

          this.onDropImage($(e.relatedTarget)
            .find('img')
            .attr('src'), e.dragEvent.pageX, e.dragEvent.pageY);
        }
        WBUtils.canvasHoverPanel.hide();
      },
      ondragenter: (e) => {
        WBUtils.canvasHoverPanel.show();
      },
      ondragleave: (e) => {
        WBUtils.canvasHoverPanel.hide();
      }
    });
  }

  /**
     * Creates and object at position (anchorX/anchorY) with the current
     * shape factory and renders the canvas.
     */
  public createObject(anchorX: number, anchorY: number): any {
    if (!this.isInWritingMode) {
      const shape = this.shapeFactory.create(anchorX, anchorY, this.color, this.fill, this.stroke);
      if (shape !== null) {
        this.canvas.add(shape);
      }
      if (this.drawingMode === DrawingMode.TEXT) {
        this.canvas.backgroundColor = '#eee';
      }
      this.canvas.renderAll();
      return shape;
    }
  }

  public removeObject(object: any) {
    this.canvas.remove(object);
  }

  public modifyObject(anchorX: number, anchorY: number, eventX: number, eventY: number) {
    this.shapeFactory.modify(anchorX, anchorY, eventX, eventY);
    this.canvas.renderAll();
  }

  /**
     * Clones the object with custom attributes 'id' and 'awtype via shape factory,
     * drops the clone and removes the original from the canvas.
     */
  public copyAndDropObject(id: number, awtype: string) {
    this.shapeFactory.copyAndDrop(id, awtype, (clone) => {
      this.addLongClickListener(clone);
      this.canvas.add(clone);
      this.canvas.renderAll();
      this.incrementUniqueElementId();

      if (this.drawingMode === DrawingMode.TEXT) {
        this.bindTextListenersToTextObject(clone);
        this.isInWritingMode = true;
      }
    });
  }

  /**
     * Sends a real time event when creating an object with anchor
     * points data.
     */
  private sendCreateData(anchorX: number, anchorY: number) {
    this.synchronization.sendRealTimeEvent(
      `WhiteboardWidget${WBUtils.widgetName}CreateObject`, {
        anchorX: anchorX,
        anchorY: anchorY
      });
  }

  /**
     * Sends a real time event when modifying an object with anchor
     * points data and event position data.
     */
  private sendModifyData(anchorX: number, anchorY: number, eventX: number, eventY: number) {
    this.synchronization.sendRealTimeEvent(
      `WhiteboardWidget${WBUtils.widgetName}$ModifyObject`, {
        anchorX: anchorX,
        anchorY: anchorY,
        eventX: eventX,
        eventY: eventY
      });
  }

  /**
     * Sends a real time event when dropping an object id and awtype data.
     */
  private sendDropSyncData(id: number, awtype: string) {
    this.synchronization.sendRealTimeEvent(
      `WhiteboardWidget${WBUtils.widgetName}DropObject`, {
        id: id,
        awtype: awtype
      });
  }

  private bindTextListenersToTextObject(text: any) {
    this.bindKeyPressListenerToTextObject(text);
    this.bindKeyUpListenerToTextObject(text);
  }

  /**
     * Binds the key press listener to a text object after creating it.
     * Also sends a real time event.
     */
  private bindKeyPressListenerToTextObject(text: any) {
    $(document).on('keypress', (e) => {
      if (e.key === 'Enter') {
        this.elementString = this.elementString + '\n';
      } else if (e.key.length === 1) {
        this.elementString = this.elementString + e.key;
      }
      text.set('text', this.elementString);

      this.synchronization.sendRealTimeEvent(`WhiteboardWidget${WBUtils.widgetName}UpdateTextObject`, {
        id: text.id,
        text: this.elementString
      });
      this.canvas.renderAll();
    });
  }

  /**
     * Binds the key up listener to a text object after creating it.
     * Also sends a real time event. Specifically made for listening
     * for 'backspace'-Event.
     */
  private bindKeyUpListenerToTextObject(text: any) {
    $(document).on('keyup', (e) => {
      if (e.key === 'Backspace') {
        this.elementString = this.elementString.substring(0, this.elementString.length - 1);
      }
      text.set('text', this.elementString);
      this.synchronization.sendRealTimeEvent(`WhiteboardWidget${WBUtils.widgetName}UpdateTextObject`, {
        id: text.id,
        text: this.elementString
      });
      this.canvas.renderAll();
    });
  }

  /**
     * Returns from text modification mode and unbinds keypress
     * and keyup listeners from text object.
     */
  stopModifyText() {
    this.isInWritingMode = false;
    this.canvas.backgroundColor = '#fff';
    $(document).off('keypress');
    $(document).off('keyup');
    this.checkDroppedText(this.getUniqueElementId() - 1);
    this.canvas.renderAll();
  }

  /**
     * Executed on every text input while modifying text object. If text is
     * empty or initial state, the text object gets removed and a real time
     * event is sent.
     */
  private checkDroppedText(adjustedElementID: number) {
    const text = this.getFabricObjectById(adjustedElementID);
    if (text.get('text').split('_').join('').trim() === '') {
      this.canvas.remove(text);
      this.synchronization.sendRealTimeEvent(
        `WhiteboardWidget${WBUtils.widgetName}DeleteObject`, {
          id: text.id
        });
    } else {
      text.set('backgroundColor', 'rgba(0,0,0,0)');
    }
  }

  /**
     * Checks for hovering custom whiteboard-dropzones on each call of onMouseMove().
     * If pointer position is over a css class 'whiteboarddropzone', the respective
     * element gets highlighted, otherwise the highlightings are removed.
     * TODO: after project inspection by expert, refactor into four submethods:
     * - onHoverTaskWBDropzone()
     * - onHoverStoryWBDropzone()
     * - onHoverGalleryWBDropzone()
     * - onWBDropzoneHoverExit()
     */
  private checkCustomDropzoneOnMouseMove(pointer: any) {
    if (this.anchorLeftCanvasSet) {
      const absolutePointerX = pointer.x + $(WBUtils.canvasHTML_ID).offset().left;
      const absolutePointerY = pointer.y + $(WBUtils.canvasHTML_ID).offset().top;
      const adjustedX = absolutePointerX - WBUtils.canvasDraggable.width() * 0.5;
      const adjustedY = absolutePointerY - WBUtils.canvasDraggable.height() * 0.5;
      WBUtils.canvasDraggable.css('left', adjustedX);
      WBUtils.canvasDraggable.css('top', adjustedY);
      let iterationLocked = false;

      $('.whiteboarddropzone').each((index, target) => {
        if (this.checkIfPointIsInsideArea(absolutePointerX, absolutePointerY, $(target))) {
          if (this.attributeExists($(target), WBUtils.taskDataAttr)) {
            this.dropTaskActivated = true;
            this.activeDropTaskID = $(target).attr(WBUtils.taskDataAttr);
            $(target).addClass(WBUtils.dropTarget);
            iterationLocked = true;
          }
          if (this.attributeExists($(target), WBUtils.storyDataAttr)) {
            this.dropStoryActivated = true;
            this.activeDropStoryID = $(target).attr(WBUtils.storyDataAttr);
            $(target).addClass(WBUtils.dropTarget);
            iterationLocked = true;
          }
          if ($(target).parent().hasClass(WBUtils.galleryWidgetClass)) {
            if (!$(WBUtils.galleryDropIndicator).is(':visible')) {
              $(WBUtils.galleryDropIndicator).css('display', 'block');
            }
            this.dropGalleryActivated = true;
            iterationLocked = true;
          }
        } else {
          if (!iterationLocked) {
            $(WBUtils.whiteboardDropZoneClass).removeClass(WBUtils.dropTarget);
            this.dropTaskActivated = false;
            this.activeDropTaskID = '';
            this.dropStoryActivated = false;
            this.activeDropStoryID = '';
            this.dropGalleryActivated = false;
            if ($(WBUtils.galleryDropIndicator).is(':visible')) {
              $(WBUtils.galleryDropIndicator).css('display', 'none');
            }
          }
        }
      });
    }
  }

  /**
     * Checks all custom whiteboard dropzones once onMouseUp().
     * If there is an element with css class '.whiteboarddropzone' beneath,
     * the preview image gets dropped onto the respective element.
     */
  private checkCustomDropzonesOnMouseUp() {
    if (this.dropStoryActivated && this.activeDropStoryID !== '') {
      this.wbIOService.onDropCanvasToIssue(Number(this.activeDropStoryID));
      $(WBUtils.whiteboardDropZoneClass).removeClass(WBUtils.dropTarget);
    }
    if (this.dropTaskActivated && this.activeDropTaskID !== '') {
      this.wbIOService.onDropCanvasToIssue(Number(this.activeDropTaskID));
      $(WBUtils.whiteboardDropZoneClass).removeClass(WBUtils.dropTarget);
    }
    if (this.dropGalleryActivated) {
      this.wbIOService.saveWhiteboardAsImageInGallery(this.dynamicCanvas);
      if ($(WBUtils.galleryDropIndicator).is(':visible')) {
        $(WBUtils.galleryDropIndicator).css('display', 'none');
      }
    }
  }

  private attributeExists(element: any, attribute: string): boolean {
    const attr = element.attr(attribute);
    return typeof attr !== typeof undefined && attr !== false;
  }

  private checkIfPointIsInsideArea(x: number, y: number, areaElem: any): boolean {
    const tcL = areaElem.offset().left;
    const tcR = tcL + areaElem.outerWidth();
    const tcT = areaElem.offset().top;
    const tcB = tcT + areaElem.outerHeight();
    return (x > tcL && x < tcR && y > tcT && y < tcB);
  }

  /**
     * EXPERIMENTAL
     * When drawing a line, this methods checks whether there are UML-Objects to Snap near
     * the current mouse- or touch position. This method is not yet refactored.
     */
  private checkObjectsToSnap(pointer: any): number[] {
    let minDistance = this.MIN_DISTANCE;
    let width, height, top, left, distance;
    let nearestX = 0;
    let nearestY = 0;
    const anchorX = pointer.x;
    const anchorY = pointer.y;

    this.canvas.getObjects().forEach((obj) => {
      if (obj.awtype === 'uml' || obj.awtype === 'diamond') {
        top = obj.top;
        left = obj.left;
        width = obj.width * obj.scaleX;
        height = obj.height * obj.scaleY;

        // check left side
        distance = this.calculateDistanceBetweenPoints(anchorX, anchorY, left, top + (height / 2));
        if (this.isNear(anchorX, anchorY, left, top + (height / 2))) {
          if (distance < minDistance) {
            minDistance = distance;
            nearestX = left;
            nearestY = top + (height / 2);
          }
        }
        // check top side
        distance = this.calculateDistanceBetweenPoints(anchorX, anchorY, left + (width / 2), top);
        if (this.isNear(anchorX, anchorY, left + (width / 2), top)) {
          if (distance < minDistance) {
            minDistance = distance;
            nearestX = left + (width / 2);
            nearestY = top;
          }
        }
        // check right side
        distance = this.calculateDistanceBetweenPoints(anchorX, anchorY, left + width, top + (height / 2));
        if (this.isNear(anchorX, anchorY, left + width, top + (height / 2))) {
          if (distance < minDistance) {
            minDistance = distance;
            nearestX = left + width;
            nearestY = top + (height / 2);
          }
        }
        // check bottom side
        distance = this.calculateDistanceBetweenPoints(anchorX, anchorY, left + (width / 2), top + height);
        if (this.isNear(anchorX, anchorY, left + (width / 2), top + height)) {
          if (distance < minDistance) {
            minDistance = distance;
            nearestX = left + (width / 2);
            nearestY = top + height;
          }
        }
      }
    });

    if (minDistance === this.MIN_DISTANCE) {
      return [];
    } else {
      return [nearestX, nearestY];
    }
  }

  private calculateDistanceBetweenPoints(x1: number, y1: number, x2: number, y2: number) {
    const a = x1 - x2;
    const b = y1 - y2;
    return Math.sqrt(a * a + b * b);
  }

  /**
     * Checks if a point (x/y) is near a point (cx/cy). The required minimum
     * distance is specified with the constant MIN_DISTANCE.
     */
  private isNear(x: number, y: number, cx: number, cy: number): boolean {
    return (((x - cx) * (x - cx) + (y - cy) * (y - cy)) < this.MIN_DISTANCE * this.MIN_DISTANCE);
  }

  /**
     * Iterates all fabric canvas objects and removes the 'lockMovement' attributes.
     */
  setAllObjectsMovable() {
    this.canvas.getObjects().forEach((obj) => {
      obj.lockMovementY = false;
      obj.lockMovementX = false;
    });
    if (this.canvas.getActiveObject()) {
      this.canvas.getActiveObject().set({
        'lockMovementY': false,
        'lockMovementX': false
      });
    }
  }

  /**
     * Executed when an fabric selection is moved. Checks if it's a single object
     * or a group selection and sends the real time events with position data.
     */
  onMoveObject(e: any) {
    const activeMainObject = this.canvas.getActiveObject();
    const target = $(WBUtils.canvasWrapperClass);
    const title = $(WBUtils.widgetTitleClass);

    if (this.checkIfObjectOutsideCanvas(activeMainObject, target, title)) {
      this.onDragOutObjectFromWhiteboard(activeMainObject);
    } else {
      if (this.anchorLeftCanvasSet) {
        this.anchorLeftCanvasSet = false;
      }
    }

    if (activeMainObject.type === 'activeSelection') {
      this.canvas.getActiveObjects().forEach((obj) => {
        this.synchronization.sendRealTimeEvent(
          `WhiteboardWidget${WBUtils.widgetName}MoveObject`, {
            id: obj.id,
            left: obj.group.left + obj.group.width / 2 + obj.left,
            top: obj.group.top + obj.group.height / 2 + obj.top
          });
      });
    } else {
      this.synchronization.sendRealTimeEvent(
        `WhiteboardWidget${WBUtils.widgetName}MoveObject`, {
          id: activeMainObject.id,
          left: activeMainObject.left,
          top: activeMainObject.top
        });
    }

    this.moveSelectionContext(activeMainObject);
    this.checkLongClickPosition(e);
  }

  /**
     * Checks if the moven fabric canvas selection is dragged more than 50% outside the whiteboard.
     * The three arguments are DOM-elements and required to calculate the absolute size of the widget.
     */
  private checkIfObjectOutsideCanvas(activeMainObject: any, target: any, title: any): boolean {
    return (activeMainObject.left < 0 - activeMainObject.width / 2
      || activeMainObject.top < 0 - activeMainObject.height / 2
      || activeMainObject.left > target.width() - activeMainObject.width / 2
      || activeMainObject.top > target.height() - title.height() - activeMainObject.height / 2);
  }

  /**
     * Executed when a fabric canvas selection is dragged outside the whiteboard. It sets anchor points
     * and states, transforms the selection back to its original place and calls the function for
     * preparing the draggable image.
     */
  private onDragOutObjectFromWhiteboard(activeMainObject: any) {
    if (!this.anchorLeftCanvasSet) {
      this.anchorLeftCanvasSet = true;
      this.anchorLeftCanvasX = activeMainObject.left;
      this.anchorLeftCanvasY = activeMainObject.top;
      activeMainObject.left = this.anchorOnMoveX;
      activeMainObject.top = this.anchorOnMoveY;
      activeMainObject.selectable = true;
      activeMainObject.selected = true;
      if (activeMainObject.type === 'activeSelection') {
        this.canvas.getActiveObjects().forEach((obj) => {
          obj.selectable = true;
          obj.selected = true;
        });
      }
      activeMainObject.lockMovementX = true;
      activeMainObject.lockMovementY = true;
      this.canvas.renderAll();
      this.prepareDraggableImage();
    }
  }

  /**
     * Executed when a fabric selection is scaled. Sends different real time events for single
     * or multi selection in order to scale correctly. Altough a user scales a multi selection at
     * once, the synced clients must scale their objects one by one in order to preserve the correct
     * position of the elements.
     */
  onScaleObject(e: any) {
    const activeMainObject = this.canvas.getActiveObject();

    if (activeMainObject.type === 'activeSelection') {
      this.canvas.getActiveObjects().forEach((obj) => {
        this.synchronization.sendRealTimeEvent(
          `WhiteboardWidget${WBUtils.widgetName}ScaleObject`, {
            id: obj.id,
            scaleX: activeMainObject.scaleX,
            scaleY: activeMainObject.scaleY,
            single: false,
            left: (activeMainObject.left + ((activeMainObject.width / 2) + obj.left) * activeMainObject.scaleX).toFixed(2),
            top: (activeMainObject.top + ((activeMainObject.height / 2) + obj.top) * activeMainObject.scaleY).toFixed(2)
          });
      });
    } else {
      this.synchronization.sendRealTimeEvent(
        `WhiteboardWidget${WBUtils.widgetName}ScaleObject`, {
          id: activeMainObject.id,
          scaleX: activeMainObject.scaleX,
          scaleY: activeMainObject.scaleY,
          single: true,
          left: activeMainObject.left,
          top: activeMainObject.top
        });
    }
    this.moveSelectionContext(activeMainObject);
  }

  /**
     * Executed when rotating a fabric selection. Sends a real time event with the id and the new angle.
     */
  onRotateObject(e) {
    const activeMainObject = this.canvas.getActiveObject();
    this.synchronization.sendRealTimeEvent(`WhiteboardWidget${WBUtils.widgetName}RotateObject`, {
      id: activeMainObject.id,
      angle: activeMainObject.angle
    });
    this.moveSelectionContext(activeMainObject);
  }

  /**
     * Executed when a fabric selection is made on the canvas. Sets anchor points for retransforming
     * the selection onDragOut.
     */
  onSelectObject() {
    const activeMainObject = this.canvas.getActiveObject();
    if (activeMainObject.type === 'activeSelection') {
      activeMainObject.hasRotatingPoint = false;
      this.addLongClickListener(activeMainObject);
      this.canvas.renderAll();
    }
    $(WBUtils.selectionContextClass).show();
    this.moveSelectionContext(activeMainObject);
    this.anchorOnMoveX = activeMainObject.left;
    this.anchorOnMoveY = activeMainObject.top;
    this.anchorLeftCanvasSet = false;
  }

  /**
     * Moves the selection context menu according to a movement of the selection.
     */
  moveSelectionContext(obj: any) {
    const top = obj.top - $(WBUtils.selectionContextClass).height();
    const left = obj.left + this.LONG_CLICK_COPY_OFFSET;
    $(WBUtils.selectionContextClass).css({
      'top': top + 'px',
      'left': left + 'px'
    });
  }

  addLongClickListenerToRenderedObjects() {
    this.canvas.getObjects().forEach((obj) => {
      this.addLongClickListener(obj);
    });
  }

  /**
     * Adds a long click listener to execute the cloning of an object. Two timers are used:
     * - spinnerDelayTimer is an initial delay, after which the animation is shown
     * - pressTimer executes pressTimerCopyFunction(obj) when not interrupted
     */
  addLongClickListener(object: any) {
    object.on('mousedown', (e) => {
      if (this.drawingMode === DrawingMode.SELECTION) {
        this.timerStarted = true;
        this.spinnerDelayTimer = window.setTimeout(() => {
          WBUtils.spinnerWrapper.css('left', this.absoluteX);
          WBUtils.spinnerWrapper.css('top', this.absoluteY);
          WBUtils.spinnerWrapper.show();
        }, this.LONG_CLICK_COPY_SPINNER_DELAY);

        this.pressTimer = window.setTimeout(() => {
          this.pressTimerCopyFunction(object);
        }, this.LONG_CLICK_COPY_DURATION);
      }
    });

    object.on('mouseup', (e) => {
      this.clearLongClickTimer();
    });
  }

  /**
     * Copies an object onto the canvas near the original one. Also sends a real time event for
     * synchronisation.
     */
  private pressTimerCopyFunction(object: any) {
    if (object.type === 'activeSelection') {
      this.canvas.getActiveObjects().forEach((obj) => {
        this.copyObject(obj, this.getUniqueElementId(),
          obj.group.left + obj.group.width / 2, obj.group.top + obj.group.height / 2);
        this.synchronization.sendRealTimeEvent(
          `WhiteboardWidget${WBUtils.widgetName}CopyObject`, {
            id: obj.id
          });
        this.incrementUniqueElementId();
      });
    } else {
      this.copyObject(object, this.getUniqueElementId());
      this.synchronization.sendRealTimeEvent(
        `WhiteboardWidget${WBUtils.widgetName}CopyObject`, {
          id: object.id
        });
      this.incrementUniqueElementId();
    }
    WBUtils.spinnerWrapper.hide();
  }

  /**
     * Checks if a movement during a long-click exceeds the max amount for disabling
     * the long click listener. Used for suppressing copying objects while moving them.
     */
  checkLongClickPosition(e: any) {
    if (this.drawingMode === DrawingMode.SELECTION && this.timerStarted) {
      const pointer = this.canvas.getPointer(e.e);

      if (Math.abs(this.longClickX - pointer.x) > this.LONG_CLICK_COPY_RESET_DISTANCE
        || Math.abs(this.longClickY - pointer.y) > this.LONG_CLICK_COPY_RESET_DISTANCE) {
        this.clearLongClickTimer();
      }
    }
  }

  clearLongClickTimer() {
    clearTimeout(this.pressTimer);
    clearTimeout(this.spinnerDelayTimer);
    this.timerStarted = false;
    WBUtils.spinnerWrapper.hide();
  }

  setDrawingMode(drawingMode: DrawingMode) {
    DrawingModeHandler.setDrawingMode(this, drawingMode);
  }

  setColor(color: string) {
    this.color = color;
    this.canvas.freeDrawingBrush.color = color;
    $(WBUtils.colorIconClass).css('color', color);
    this.colorSelection(color);
  }

  /**
     * When choosing a color, this function gets executed and checks, if there is an active
     * selection. If so, the objects inside the selection get colored according to the chosen
     * color.
     */
  colorSelection(color: string) {
    this.canvas.getActiveObjects().forEach((obj) => {
      if (obj.type === 'group') {
        obj.forEachObject(c => {
          c.set('stroke', color);
          this.synchronization.sendRealTimeEvent(
            `WhiteboardWidget${WBUtils.widgetName}ColorElement`, { id: c.id, color: color });
        });
      } else {
        obj.set('stroke', color);
        this.synchronization.sendRealTimeEvent(
          `WhiteboardWidget${WBUtils.widgetName}ColorElement`, { id: obj.id, color: color });
      }
    });
    this.canvas.renderAll();
  }

  /**
     * Colors the element with the given id according to the given color.
     */
  colorElement(id: number, color: string) {
    this.getFabricObjectById(id).set('stroke', color);
    this.canvas.renderAll();
  }

  setFill(color: string) {
    this.fill = color;
    $(WBUtils.fillIconClass).css('color', (color === 'rgba(0,0,0,0)') ? 'white' : color);
    this.fillSelection(color);
  }

  /**
     * When choosing a fill color, this function gets executed and checks, if there is an active
     * selection. If so, the objects inside the selection get filled according to the chosen
     * color.
     */
  fillSelection(color) {
    this.canvas.getActiveObjects().forEach((obj) => {
      if (obj.type === 'group') {
        obj.forEachObject(c => {
          c.set('fill', color);
          this.synchronization.sendRealTimeEvent(
            `WhiteboardWidget${WBUtils.widgetName}FillElement`, { id: c.id, color: color });
        });
      } else {
        obj.set('fill', color);
        this.synchronization.sendRealTimeEvent(
          `WhiteboardWidget${WBUtils.widgetName}FillElement`, { id: obj.id, color: color });
      }
    });
    this.canvas.renderAll();
  }

  /**
     * Fills the element with the given id according to the given color.
     */
  fillElement(id: number, color: string) {
    this.getFabricObjectById(id).set('fill', color);
    this.canvas.renderAll();
  }

  setStrokeWidth(width: number) {
    this.stroke = width;
    this.canvas.freeDrawingBrush.width = width;
    this.strokeWidthSelection(width);
  }

  /**
     * When choosing a stroke width, this function gets executed and checks, if there is an active
     * selection. If so, the object's stroke width inside the selection are set to the width chosen.
     */
  strokeWidthSelection(width) {
    this.canvas.getActiveObjects().forEach((obj) => {

      switch (obj.awtype) {
        case 'diamond': case 'desktop': case 'tablet': case 'phone':
          obj.set('strokeWidth', (width / obj.scaleX));
          this.synchronization.sendRealTimeEvent(
            `WhiteboardWidget${WBUtils.widgetName}StrokeElement`,
            { id: obj.id, width: width / obj.scaleX });
          break;

        case 'text':
          break;

        default:
          if (obj.type === 'group') {
            obj.forEachObject(c => {
              c.set('strokeWidth', width);
              this.synchronization.sendRealTimeEvent(
                `WhiteboardWidget${WBUtils.widgetName}StrokeElement`,
                { id: c.id, width: width });
            });
          } else {
            obj.set('strokeWidth', width);
            this.synchronization.sendRealTimeEvent(
              `WhiteboardWidget${WBUtils.widgetName}StrokeElement`,
              { id: obj.id, width: width });
          }
          break;
      }
    });
    this.canvas.renderAll();
  }

  /**
     * Sets the stroke width of an object with given id to given width.
     */
  strokeElement(id: number, width: number) {
    this.getFabricObjectById(id).set('strokeWidth', width);
    this.canvas.renderAll();
  }

  /**
     * Renders a new image for the canvas preview on the reset widget and places it in the
     * HTML element.
     */
  updateMiniCanvasPreview() {
    setTimeout(() => {
      WBUtils.canvasPreview
        .html('<img class="widget-canvas-preview" src="' + this.canvas.toDataURL('image/png') + '" />')
        .show();
    }, this.CANVAS_PREVIEW_TIMEOUT);
  }

  /**
     * Searches the highest id of all canvas objects present and sets the unique
     * element id to this value + 1.
     */
  adjustUniqueElementId() {
    let max = 0;
    this.canvas.getObjects().forEach((obj) => {
      if (Number(obj.id) > max) {
        max = Number(obj.id);
      }
    });
    this.uniqueElementId = ++max;
  }

  /**
     * Prepares the draggable image shown in the mini-view onDragOut from whiteboard.
     * For single or multi selection, the according function is called. After receiving
     * the image, it gets placed in the draggable div-element and transformed to the
     * user position. After that, the rendered image is saved on the file system for later use.
     */
  prepareDraggableImage() {
    const selectedObject = fabric.util.object.clone(this.canvas.getActiveObject());
    this.dynamicCanvas = new fabric.Canvas(WBUtils.dynamicCanvasHTML_ID, {
      preserveObjectStacking: true
    });

    if (selectedObject.type !== 'activeSelection') {
      this.renderSingleSelectionDynamicCanvas(selectedObject);
    } else {
      this.renderMultiSelectionCanvas(selectedObject);
    }

    WBUtils.canvasDraggable.html('<img class="dragPreview" src="' + this.dynamicCanvas.toDataURL('image/png')
      + '" style="width:100%; height: 100%;" />').show();

    // TODO drag-preview-element is not placed correctly
    WBUtils.canvasDraggable.css('left', this.anchorLeftCanvasX + WBUtils.whiteboardWidget.offset().left);
    WBUtils.canvasDraggable.css('top', this.anchorLeftCanvasY + WBUtils.whiteboardWidget.offset().top);

    WBUtils.canvasDraggable.css('display', 'flex');
    this.wbIOService.createNewTempFileName();

    const imageData = this.dynamicCanvas.toDataURL('image/png').replace('image/png', 'image/octet-stream') as string;
    const imageFilename = this.wbIOService.getCurrentTempFileName();
    this.wbIOService.saveDraggablePreviewAsImage(imageData, imageFilename);
  }

  /**
     * Renders a single selection as image on the dynamic canvas. The size of the dynamic canvas
     * is set to the objects width resp. height, both with additional padding.
     */
  renderSingleSelectionDynamicCanvas(selectedObject: any) {
    const totalWidth = selectedObject.width * selectedObject.scaleX;
    const totalHeight = selectedObject.height * selectedObject.scaleY;
    this.dynamicCanvas.setWidth(totalWidth + 2 * this.DEFAULT_PADDING);
    this.dynamicCanvas.setHeight(totalHeight + 2 * this.DEFAULT_PADDING);
    selectedObject.set({
      left: this.DEFAULT_PADDING,
      top: this.DEFAULT_PADDING
    });
    this.dynamicCanvas.add(selectedObject);
    this.dynamicCanvas.renderAll();
  }

  /**
     * Renders a multi selection as image on the dynamic canvas. The size of the dynamic canvas
     * is set to the objects width resp. height, both with additional padding.
     */
  renderMultiSelectionCanvas(multiSelectionObject: any) {
    const clonedObjects: Array<any> = [];

    multiSelectionObject.forEachObject(obj => {
      clonedObjects.push(fabric.util.object.clone(obj));
    });

    const group = new fabric.Group(clonedObjects, {
      left: this.DEFAULT_PADDING,
      top: this.DEFAULT_PADDING,
      width: multiSelectionObject.width,
      height: multiSelectionObject.height,
      originX: multiSelectionObject.originX,
      originY: multiSelectionObject.originY,
      scaleX: multiSelectionObject.scaleX,
      scaleY: multiSelectionObject.scaleY
    });
    const totalWidth = multiSelectionObject.width + 2 * this.DEFAULT_PADDING;
    const totalHeight = multiSelectionObject.height + 2 * this.DEFAULT_PADDING;
    this.dynamicCanvas.setWidth(totalWidth);
    this.dynamicCanvas.setHeight(totalHeight);
    this.dynamicCanvas.add(group);
    this.dynamicCanvas.renderAll();
  }

  /**
     * Sends all whiteboard states and values for syncing two clients with a real time event.
     */
  sendSyncContents(newUsers: number) {
    this.synchronization.sendRealTimeEvent(`WhiteboardWidget${WBUtils.widgetName}SyncWhiteboardContent`, {
      ueid: this.getUniqueElementId(),
      users: newUsers,
      content: this.getSerializedMainCanvas(),
      color: this.color,
      fill: this.fill,
      stroke: this.stroke,
      fontSize: this.fontSize,
      drawingMode: this.drawingMode,
      smallView: this.mainModule.getIsSmallView(),
      fullScreen: this.mainModule.getIsFullScreen(),
      transform: this.mainModule.getTarget().style.transform,
      inWritingMode: this.isInWritingMode,
      canvasLoaded: this.canvasLoaded,
      currentTempFileName: this.wbIOService.getCurrentTempFileName(),
      currentProjectWhiteboard: this.wbIOService.getCurrentProjectWhiteboard(),
      x: this.mainModule.getTarget().getAttribute('data-x'),
      y: this.mainModule.getTarget().getAttribute('data-y'),
      w: WBUtils.whiteboardWidget.width(),
      h: WBUtils.whiteboardWidget.height()
    });
  }

  /**
     * Syncs all states and values according to the received real time event 'SyncContent'.
     */
  syncContent(data) {
    this.uniqueElementId = Number(`${data.ueid}`);

    this.canvas.loadFromJSON(`${data.content}`, () => {
      this.canvas.renderAll();
      this.mainModule.setIsVTRSynced(true);
      this.addLongClickListenerToRenderedObjects();
    });

    this.setColor(`${data.color}`);
    this.setFill(`${data.fill}`);
    this.setStrokeWidth(Number(`${data.stroke}`));
    this.fontSize = Number(`${data.fontSize}`);
    this.isInWritingMode = `${data.inWritingMode}` === 'true';
    this.canvasLoaded = `${data.canvasLoaded}` === 'true';
    this.wbIOService.setCurrentProjectWhiteboard(data.currentProjectWhiteboard);
    this.wbIOService.setCurrentTempFileName(data.currentTempFileName);

    this.drawingMode = Number(`${data.drawingMode}`);
    DrawingModeHandler.setDrawingMode(this, this.drawingMode);

    if (this.mainModule.getIsSmallView() || this.mainModule.getIsFullScreen()) {
      WBUtils.canvasPreview.hide();
      WBUtils.canvasContainer.show();
      WBUtils.canvasDropZone.css('overflow', 'hidden');
      if (this.mainModule.getIsSmallView()) {
        WBUtils.widgetResizer.css('bottom', - WBUtils.buttonWrapper.height() - this.RESIZER_OFFSET);
        WBUtils.widgetResizer.css('left', this.RESIZER_OFFSET * -1);
        WBUtils.toolButton.show();
      }
    }

    this.mainModule.setIsSmallView((`${data.smallView}` === 'true'));
    this.mainModule.setIsFullScreen((`${data.fullScreen}` === 'true'));
    this.mainModule.getTarget().setAttribute('data-x', Number(`${data.x}`));
    this.mainModule.getTarget().setAttribute('data-y', Number(`${data.y}`));
    this.mainModule.getTarget().style.transform = `${data.transform}`;

    if (!this.mainModule.getIsSmallView()) {
      WBUtils.whiteboardWidget.addClass('resizedwidget');
      WBUtils.whiteboardWidget.width(Number(`${data.w}`));
      WBUtils.whiteboardWidget.height(Number(`${data.h}`));
    } else {
      this.mainModule.resetWidget(this.mainModule.getTarget());
    }
  }

  /**
     * In order to sync free hand drawing, the event path:dropped is listened to. When dropping
     * a free hand path, a real time event gets sent and this funtion called by the client.
     */
  dropSyncedPath(data: any) {
    const tmpObject = JSON.parse(`${data.json}`);
    fabric.util.enlivenObjects([tmpObject], (objects) => {
      objects.forEach((o) => {
        this.canvas.add(o);
      });
      this.canvas.renderAll();
      this.incrementUniqueElementId();
    }, null);
  }

  /**
     * Calls the function on the whiteboard io service for saving the canvas project as file. If
     * emitRealtimeEvent is true, a real time event is sent for syncing. The two callback functions are
     * provided by the whiteboard widget component.
     */
  saveCanvasContentInProject(emitRealtimeEvent: boolean, onList: (wbs) => void, showIcon: () => void) {
    this.wbIOService.saveCanvasContentInProject(emitRealtimeEvent, onList,
      (current) => {
        this.clearCanvas(true);
        this.resetUniqueElementId();
        this.mainModule.setWhiteboardStateLabel(current);
      },
      showIcon,
      this.getSerializedMainCanvas());
  }

  /**
     * Loads all whiteboards of a specified JIRA project. If there is data,
     * the data is processed and eventually a whiteboard gets loaded and the recent panel gets
     * filled. If not, a new whiteboard gets created.
     */
  loadProjectWhiteboards() {
    this.setProjectBaseURL(`${this.configService.settings.pyWallServer.url}projects`);
    this.wbIOService.loadProjectWhiteboards(
      (wbs) => {
        this.setCanvasLoaded(true);
        const wb = wbs[wbs.length - 1];
        this.loadWhiteboard(wb.url, true);
        const wbUrlSplit = wb.url.split('/');
        this.mainModule.setWhiteboardStateLabel(wbUrlSplit[wbUrlSplit.length - 1]);
        this.mainModule.fillHistoryPanel(wbs);
      },
      (current) => {
        this.clearCanvas(true);
        this.resetUniqueElementId();
        this.mainModule.setWhiteboardStateLabel(current);
        this.wbIOService.createNewProjectFileName();
        this.mainModule.fillHistoryPanel([]);
        this.saveCanvasContentInProject(
          true,
          (wbs) => {
            this.mainModule.fillHistoryPanel(wbs);
            this.canvas.renderAll();
          },
          () => {
            this.mainModule.showIconAfterSaving();
          });
      });
  }


  // TODO fix 2-parameter emitRealtimeEvent, why?
  /**
     * Loads a whiteboard by loading the file at the specified url. If forceSync
     * is set to true, it sends a real time event.
     */
  loadWhiteboard(url: string, emitRealtimeEvent: boolean) {
    this.wbIOService.loadWhiteboard(this.pyWallBaseUrl, url, emitRealtimeEvent,
      (emitRealtimeEvent2, currentProjectWB, urlInner, raw) => {
        this.canvas.loadFromJSON(atob(raw.responseText), () => {
          this.canvas.renderAll();
          this.adjustUniqueElementId();
          this.mainModule.closeCanvasPreview();
          this.addLongClickListenerToRenderedObjects();

          if (this.mainModule.getIsSmallView()) {
            this.updateMiniCanvasPreview();
          }

          WBUtils.whiteboardStateLabel.html(currentProjectWB);

          if (emitRealtimeEvent2) {
            this.synchronization.sendRealTimeEvent(
              `WhiteboardWidget${WBUtils.widgetName}LoadWhiteboard`, {
                url: urlInner
              });
          }
        });
      },
      this.getCurrentProjectWhiteboard());
  }

  /**
     * Executed when dropping an image onto the whiteboard. It calculates sizes, calls dropImage() and
     * sends a real time event.
     */
  private onDropImage(src: string, x: number, y: number) {
    const offsetL = WBUtils.whiteboardWidget.find(WBUtils.widgetClass).offset().left;
    const offsetT = WBUtils.whiteboardWidget.find(WBUtils.widgetClass).offset().top;
    const titleH = WBUtils.whiteboardWidget.find(WBUtils.widgetTitleClass).outerHeight(true);
    const anchorX = x - offsetL;
    const anchorY = y - offsetT - titleH;
    this.dropImage(src, anchorX, anchorY);

    this.synchronization.sendRealTimeEvent(`WhiteboardWidget${WBUtils.widgetName}DropImage`, {
      src: src,
      x: anchorX,
      y: anchorY
    });
  }

  /**
     * Called by onDropImage() and after receiving a real time event. Loads an image from the specified url
     * and drops it at position (x/y) on the canvas.
     */
  public dropImage(src: string, x: number, y: number) {
    fabric.Image.fromURL(src, (oImg) => {

      if (!this.handleOversizedImageSettings(oImg)) {
        oImg.set({
          'left': x - oImg.width / 2,
          'top': y - oImg.height / 2,
          'width': oImg.width,
          'height': oImg.height,
          'selectable': false
        });
      }

      if (this.drawingMode === DrawingMode.SELECTION) {
        oImg.set({
          'selectable': true
        });
        this.canvas.setActiveObject(oImg);
      }

      oImg.toObject = ((toObject) => function () {
        return fabric.util.object.extend(toObject.call(this), {
          id: this.id,
          awtype: 'image'
        });
      })(oImg.toObject);

      (oImg as any).id = this.getUniqueElementId();
      this.incrementUniqueElementId();
      this.canvas.add(oImg);
    }, { crossOrigin: 'anonymous' });
  }


  /**
     * This method sets a scalratio for dropped images that almost as big or bigger as the visible canvas.
     * Such images are always positioned in the upper-left corner, not on drop coordinates.
     *
     * Returns true if the image was oversized and handled accordingly or false if no action has been taken.
     */

  private handleOversizedImageSettings(fabricImage: Image): boolean {
    // If image is larger than 90% of the visible canvassize (in either height or width) we scale it
    const maxAllowedRatio = 0.9;
    const canvasContainer = document.querySelector('div.widget.canvas-dropzone');
    const visibleCanvasDimensions = canvasContainer.getBoundingClientRect();
    const widthRatio = fabricImage.width / visibleCanvasDimensions.width;
    const heightRatio = fabricImage.height / visibleCanvasDimensions.height;
    const ratio = Math.max(widthRatio, heightRatio);
    const needsScaling = ratio > maxAllowedRatio;

    if (needsScaling) {
      const scaleFactor = (maxAllowedRatio / ratio);
      fabricImage.set({
        top: 0,
        left: 0,
        scaleY: scaleFactor,
        scaleX: scaleFactor,
        'selectable': false
      });
      return true;
    } else {
      return false;
    }
  }

  /**
     * Drops a path object onto the canvas and sets an custom id to as attribute.
     */
  public dropPath(id: number) {
    const objects = this.canvas.getObjects();
    let last = null;
    if (objects.length > 0) {
      last = objects[objects.length - 1];
    }
    last.clone((clone) => {
      clone.set('selectable', false);
      this.addLongClickListener(clone);
      clone.toObject = ((toObject) => function () {
        return fabric.util.object.extend(toObject.call(this), {
          id: this.id,
          awtype: this.awtype
        });
      })(clone.toObject);

      clone.id = id;
      clone.awType = 'simple-path';
      this.canvas.add(clone);
      this.canvas.remove(last);
      this.canvas.renderAll();
      this.synchronization.sendRealTimeEvent(`WhiteboardWidget${WBUtils.widgetName}DropPath`, {
        json: JSON.stringify(clone)
      });
      this.incrementUniqueElementId();
    });
  }

  /**
     * Copies an object near the original one and gets assigned the custom attribute id.
     */
  public copyObject(object: any, id: number, groupLeft = 0, groupTop = 0) {
    object.clone((clone) => {
      this.addLongClickListener(clone);
      clone.toObject = ((toObject) => function () {
        return fabric.util.object.extend(toObject.call(this), {
          id: this.id,
          awtype: this.awtype
        });
      })(clone.toObject);
      clone.id = id;
      clone.awType = object.awtype;
      this.canvas.add(clone.set({
        left: object.left + 40 + groupLeft,
        top: object.top + 20 + groupTop
      }));
    });
  }

  public moveObject(id: number, left: number, top: number) {
    this.getFabricObjectById(id).set({
      left: left,
      top: top
    });
    this.canvas.renderAll();
  }

  public scaleObject(id: number, scaleX: number, scaleY: number, single: boolean, left: number, top: number) {
    if (single) {
      this.getFabricObjectById(id).set({
        scaleX: scaleX,
        scaleY: scaleY,
        left: left,
        top: top
      });
    } else {
      this.getFabricObjectById(id).set({
        scaleX: scaleX,
        scaleY: scaleY,
        left: left,
        top: top
      });
    }

    this.canvas.renderAll();
  }

  public rotateObject(id: number, angle: number) {
    this.getFabricObjectById(id).rotate(angle);
    this.canvas.renderAll();
  }

  public copyObjectById(id: number) {
    this.copyObject(this.getFabricObjectById(id), this.uniqueElementId);
  }

  public setObjectsSelectable(selectable: boolean) {
    this.canvas.selection = selectable;
    this.canvas.renderAll();
    this.canvas.forEachObject((object) => {
      object.selectable = selectable;
    });
    if (!selectable) {
      this.canvas.discardActiveObject();
    }
    this.canvas.renderAll();
  }

  public deleteSelectedElement() {
    this.canvas.getActiveObjects().forEach((obj) => {
      this.canvas.remove(obj);
    });
    this.canvas.discardActiveObject().renderAll();
  }

  public deleteObjectById(id: number) {
    this.canvas.remove(this.getFabricObjectById(id)).renderAll();
  }

  public clearCanvas(originalInvoker: boolean) {
    this.canvas.getObjects().forEach((obj) => {
      this.canvas.remove(obj);
    });
    this.canvas.discardActiveObject().renderAll();
    this.adjustUniqueElementId();

    if (originalInvoker) {
      this.canvas.getObjects().forEach((obj) => {
        this.synchronization.sendRealTimeEvent(
          `WhiteboardWidget${WBUtils.widgetName}DeleteObject`, {
            id: obj.id
          });
      });
    }
  }

  setSelectionMode() {
    this.drawingMode = DrawingMode.SELECTION;
    this.setObjectsSelectable(true);
    this.canvas.isDrawingMode = false;
    this.shapeFactory = new SelectionFactory();
    this.mainModule.highlightToolButton(this.shapeFactory.getParentButton());
  }

  setPencilMode() {
    this.drawingMode = DrawingMode.PENCIL;
    this.setObjectsSelectable(false);
    this.canvas.isDrawingMode = true;
    this.shapeFactory = new PencilFactory();
    this.mainModule.highlightToolButton(this.shapeFactory.getParentButton());
  }

  setLineMode() {
    this.drawingMode = DrawingMode.LINE;
    this.setObjectsSelectable(false);
    this.canvas.isDrawingMode = false;
    WBUtils.pmsInner.html('show_chart');
    this.shapeFactory = new LineFactory();
    this.mainModule.highlightToolButton(this.shapeFactory.getParentButton());
  }

  setRectangleMode() {
    this.drawingMode = DrawingMode.RECTANGLE;
    this.setObjectsSelectable(false);
    this.canvas.isDrawingMode = false;
    WBUtils.pmsInner.html('crop_din');
    this.shapeFactory = new RectangleFactory();
    this.mainModule.highlightToolButton(this.shapeFactory.getParentButton());
  }

  setEllipseMode() {
    this.drawingMode = DrawingMode.ELLIPSE;
    this.setObjectsSelectable(false);
    this.canvas.isDrawingMode = false;
    WBUtils.pmsInner.html('panorama_fish_eye');
    this.shapeFactory = new EllipseFactory();
    this.mainModule.highlightToolButton(this.shapeFactory.getParentButton());
  }

  setTextMode() {
    this.drawingMode = DrawingMode.TEXT;
    this.setObjectsSelectable(false); // TODO refactor our, (if !selection )
    this.canvas.isDrawingMode = false;
    WBUtils.pmsInner.html('format_color_text');
    this.shapeFactory = new TextFactory();
    this.mainModule.highlightToolButton(this.shapeFactory.getParentButton());
  }

  setUMLMode() {
    this.drawingMode = DrawingMode.UML;
    this.setObjectsSelectable(false);
    this.canvas.isDrawingMode = false;
    WBUtils.pmsInnerAdvanced.html('credit_card');
    WBUtils.pmsInnerAdvanced.removeClass('fs-inner-angled');
    this.shapeFactory = new UMLObjectFactory();
    this.mainModule.highlightToolButton(this.shapeFactory.getParentButton());
  }

  setUMLDiamondMode() {
    this.drawingMode = DrawingMode.UML_DIAMOND;
    this.setObjectsSelectable(false);
    this.canvas.isDrawingMode = false;
    WBUtils.pmsInnerAdvanced.html('crop_square');
    WBUtils.pmsInnerAdvanced.addClass('fs-inner-angled');
    this.shapeFactory = new UMLDiamondFactory();
    this.mainModule.highlightToolButton(this.shapeFactory.getParentButton());
  }

  setPhoneShapeMode() {
    this.drawingMode = DrawingMode.SHAPE_PHONE;
    this.setObjectsSelectable(false);
    this.canvas.isDrawingMode = false;
    WBUtils.pmsInnerAdvanced.html('phone_iphone');
    WBUtils.pmsInnerAdvanced.removeClass('fs-inner-angled');
    this.shapeFactory = new ScreenPhoneFactory();
    this.mainModule.highlightToolButton(this.shapeFactory.getParentButton());
  }

  setTabletShapeMode() {
    this.drawingMode = DrawingMode.SHAPE_TABLET;
    this.setObjectsSelectable(false);
    this.canvas.isDrawingMode = false;
    WBUtils.pmsInnerAdvanced.html('tablet');
    WBUtils.pmsInnerAdvanced.removeClass('fs-inner-angled');
    this.shapeFactory = new ScreenTabletFactory();
    this.mainModule.highlightToolButton(this.shapeFactory.getParentButton());
  }

  setDesktopShapeMode() {
    this.drawingMode = DrawingMode.SHAPE_DESKTOP;
    this.setObjectsSelectable(false);
    this.canvas.isDrawingMode = false;
    WBUtils.pmsInnerAdvanced.html('desktop_windows');
    WBUtils.pmsInnerAdvanced.removeClass('fs-inner-angled');
    this.shapeFactory = new ScreenDesktopFactory();
    this.mainModule.highlightToolButton(this.shapeFactory.getParentButton());
  }

  getTempCanvas(): fabric.Canvas {
    return this.tempCanvas;
  }

  renderCanvasAll() {
    this.canvas.renderAll();
  }

  getIsDown(): boolean {
    return this.isDown;
  }

  getProjectBaseURL(): string {
    return this.pyWallBaseUrl;
  }

  getSelectedElementIds(): number[] {
    const ids = [];
    this.canvas.getActiveObject();
    if (this.canvas.getActiveObject().type === 'activeSelection') {
      this.canvas.getActiveObjects().forEach((obj) => {
        ids.push(obj.id);
      });
    } else {
      ids.push(this.canvas.getActiveObject().id);
    }

    return ids;
  }

  setProjectBaseURL(url: string) {
    this.pyWallBaseUrl = url;
  }

  incrementUniqueElementId() {
    this.uniqueElementId++;
  }

  resetUniqueElementId() {
    this.uniqueElementId = 0;
  }

  getUniqueElementId(): number {
    return this.uniqueElementId;
  }

  getSerializedMainCanvas(): string {
    return JSON.stringify(this.canvas.toJSON(['id', 'awtype']));
  }

  getTempCanvasAsDataURL(): any {
    return this.tempCanvas.toDataURL('image/jpg');
  }

  getCurrentProjectWhiteboard(): any {
    return this.wbIOService.getCurrentProjectWhiteboard();
  }

  modifyCurrentProjectWhiteboard(newName: string) {
    this.wbIOService.setCurrentProjectWhiteboard(newName);
  }

  createNewProjectWhiteBoard() {
    this.wbIOService.createNewProjectFileName();
  }

  setCanvasLoaded(loaded: boolean) {
    this.canvasLoaded = loaded;
  }

  getCanvasLoaded(): boolean {
    return this.canvasLoaded;
  }

  public getFabricObjectById(id: number): any {
    let returnObject = null;
    this.canvas.getObjects().forEach((obj) => {
      if (Number(obj.id) === id) { returnObject = obj; }
    });
    return returnObject;
  }

  toggleSnap() {
    this.snapToObjects = !this.snapToObjects;
  }
}
